export function defaultBatchDisplayName(at: Date = new Date()): string {
  // ASSUMED(batch auto-label uses "Batch YYYY-MM-DD HH:MM UTC".)
  const minute = at.toISOString().slice(0, 16).replace("T", " ");
  return `Batch ${minute} UTC`;
}
